import { Component, OnInit } from '@angular/core';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { InternalSettings } from '../../services/internal-settings/internal-settings.interface';
import { ResponsiveDesignService } from '../../services/responsive-design/responsive-design.service';
import { UIUtilityService } from '../../../system/utility/ui-utility.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { StringUtilityService } from '../../../system/utility/string-utility.service';
import { PlatformService } from 'src/app/system/utility/platform.service';

@Component({
    selector: 'app-sidebar-nav',
    templateUrl: './sidebar-nav.component.html',
    styleUrls: ['./sidebar-nav.component.less'],
    standalone: false
})
export class SidebarNavComponent implements OnInit {

  private destroy$: Subject<void> = new Subject();
  protected isShowingSidebarNav!: boolean;
  protected externalSettings!: ExternalSettings;
  protected internalSettings!: InternalSettings;
  protected StringUtilityService: any = StringUtilityService;

  PlatformService: any = PlatformService;
  UIUtilityService: any = UIUtilityService;

  constructor(
    private srvES: ExternalSettingsService,
    private srvIS: InternalSettingsService,
    private srvRpDesign: ResponsiveDesignService
  ) { }

  ngOnInit(): void {

    combineLatest([
      this.srvES.externalSettings$,
      this.srvIS.getCurrentSettings(),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([externalSettings, internalSettings]) => {

        if (!internalSettings) return;

        this.internalSettings = internalSettings;
        this.externalSettings = externalSettings;
      });

    this.srvRpDesign.getSidebarNav().subscribe((isShowingSidebarNav: boolean) => {
      this.isShowingSidebarNav = isShowingSidebarNav;
    })

  }

  protected sidebarDismiss(): void {
    this.srvRpDesign.setSidebarNav(false);
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
